/* eslint-disable import/prefer-default-export */
import { Key } from 'react';
import { Path } from 'react-router-dom';
import styled from 'styled-components';

export const RightAlign = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export interface LocationInterface extends Path {
  state: {
    node?: string | undefined;
    id: string;
    parent?: any;
    child?: any;
    data?: any;
    roadmapId?: any;
    selectedStudentData?: any;
  };
  key: Key;
}
